<form
  class="form"
  #passwordform="ngForm"
  [mustMatch]="['newpassword', 'password']"
  (ngSubmit)="passwordform.form.valid && onSubmit()"
  novalidate
>
  <div class="row">
    <div class="col-md-4">
      <div class="form-group">
        <mat-form-field class="example-full-width">
          <input
            matInput
            [type]="currentpwdhide ? 'password' : 'text'"
            placeholder="Current Password"
            [(ngModel)]="passwordFormValue.currentpassword"
            required
            name="currentpassword"
          />
          <span class="password-icon"
            mat-icon-button
            matSuffix
            (click)="currentpwdhide = !currentpwdhide"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="currentpwdhide"
          >
            <mat-icon>{{
              currentpwdhide ? 'visibility_off' : 'visibility'
            }}</mat-icon>
          </span>
        </mat-form-field>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <mat-form-field class="example-full-width">
          <input
            matInput
            [type]="newpwdhide ? 'password' : 'text'"
            placeholder="New Password"
            required
            minlength="8"
            name="newpassword"
            [(ngModel)]="passwordFormValue.newpassword"
          />
          <span class="password-icon"
            mat-icon-button
            matSuffix
            (click)="newpwdhide = !newpwdhide"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="newpwdhide"
          >
            <mat-icon>{{
              newpwdhide ? 'visibility_off' : 'visibility'
            }}</mat-icon>
          </span>
        </mat-form-field>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <mat-form-field class="example-full-width">
          <input
            matInput
            [type]="confirmpwd ? 'password' : 'text'"
            placeholder="Confirm Password"
            [(ngModel)]="passwordFormValue.password"
            required
            name="password"
          />
          <span class="password-icon"
            mat-icon-button
            matSuffix
            (click)="confirmpwd = !confirmpwd"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="confirmpwd"
          >
            <mat-icon>{{
              confirmpwd ? 'visibility_off' : 'visibility'
            }}</mat-icon>
          </span>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div style="text-align: center">
    <button 
    type="submit"
    [disabled]="!passwordform.valid" 
    mat-raised-button 
    class="btn btn-primary" 
    color="primary">
      Save
    </button>
    &nbsp;&nbsp;&nbsp;
    <a
      (click)="cancelClick()"
      mat-raised-button
      class="btn btn-light-primary btn-bold"
    >
      Cancel
    </a>
  </div>
</form>
